import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
} from "@mui/material";

import Loader from "../../../../Common/Loader/loader";
import isGHMC, { formatDateTimeWithoutSec, formattedDate, getCurrentDateTime } from "../../../../Common/helper/helpar";
import { FrequencyBinsFilter } from "./FrequencyBinsFilter";
import frequencyBinsGVPStore from "./store/frequencyBinsGVPStore";

export const FrequencyOfBinsReport = () => {
  const { frequencyBinsGVPData, loading } = frequencyBinsGVPStore();

  const navigate = useNavigate();
const location = useLocation()
const data = location.state
  /* ================= Pagination ================= */
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);

  const currentDate = getCurrentDateTime();


  useEffect(() => {
    setPage(0);
  }, [frequencyBinsGVPData]);

  /* ================= Get Filters From LocalStorage ================= */

const storedFilters = localStorage.getItem("frequencyBinsFilters");
const parsedFilters = storedFilters ? JSON.parse(storedFilters) : null;



// const fromDate = parsedFilters?.FromDate
//   ? formatDateTime(parsedFilters.FromDate)
//   : "-";

// const toDate = parsedFilters?.ToDate
//   ? formatDateTime(parsedFilters.ToDate)
//   : "-";



  /* ================= Handlers ================= */

  const handleDateClick = (date, event) => {
    event?.preventDefault();
    event?.stopPropagation();
    navigate(`/inner-frequency-bins-report`, { state: { date } });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  /* ================= Pagination Data ================= */

  const paginatedData = frequencyBinsGVPData
    ? frequencyBinsGVPData.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      )
    : [];

  /* ================= Totals ================= */

  const calculateTotals = () => {
    if (!frequencyBinsGVPData || frequencyBinsGVPData.length === 0) {
      return {
        totalGVPs: 0,
        attended: 0,
        performance: 0,
      };
    }

    const totals = frequencyBinsGVPData.reduce(
      (acc, row) => {
        acc.totalGVPs += Number(row.totalGVPs || 0); // ✅ fixed
        acc.attended += Number(row.attended || 0);
        return acc;
      },
      { totalGVPs: 0, attended: 0 }
    );

    // Average performance
    const totalPerformance = frequencyBinsGVPData.reduce(
      (sum, row) => sum + Number(row.performance || 0),
      0
    );

    totals.performance =
      frequencyBinsGVPData.length > 0
        ? (totalPerformance / frequencyBinsGVPData.length).toFixed(2)
        : 0;

    return totals;
  };

  const totals = calculateTotals();

  /* ================= Styles ================= */

  const headerStyle = {
    textAlign: "center",
    border: "1px solid #ddd",
    padding: "10px",
    color: "#fff",
    backgroundColor: isGHMC() ? "#0d5da5" : "#EC1117",
    fontWeight: 600,
    whiteSpace: "nowrap",
  };

  const cellStyle = {
    textAlign: "center",
    border: "1px solid #ddd",
    padding: "8px",
  };

  /* ================= Render ================= */

  return (
    <div style={{ width: "100%" }}>
      <div className="content">
        <div className="page-content">

          <FrequencyBinsFilter />

          <div className="card mt-3">
            <div className="card-body">

              {/* Header */}
              <div
                className="top-header p-2"
                style={{
                  backgroundColor: "#D7D7D7",
                  fontWeight: "600",
                  borderBottom: "1px solid #DDDDDD",
                }}
              >
                <span>Frequency Of GVPs Attended Daily Report as on {parsedFilters?.FromDate && parsedFilters?.ToDate
                    ? ` (${formattedDate(parsedFilters.FromDate)} to ${formattedDate(parsedFilters.ToDate)})`
                    : ""} at ({formatDateTimeWithoutSec(currentDate)})</span>
              </div>

              {/* Loader */}
              {loading ? (
                <Loader />
              ) : (
                <>
                  {/* ================= Table ================= */}

                  <TableContainer component={Paper} sx={{ maxHeight: 500 }}>
                    <Table stickyHeader>

                      {/* ================= Table Head ================= */}

                      <TableHead>
                        <TableRow>
                          <TableCell sx={headerStyle}>S.No</TableCell>
                          <TableCell sx={headerStyle}>Date</TableCell>
                          <TableCell sx={headerStyle}>Shift</TableCell>

                          <TableCell sx={headerStyle}>
                            Total number of GVP's<br/>in the All Circles<br />(a)
                          </TableCell>

                          <TableCell sx={headerStyle}>
                            Total number of GVP's<br/>Attended in the All Circles<br />(b)
                          </TableCell>

                          <TableCell sx={headerStyle}>
                            Performance
                          </TableCell>

                          <TableCell sx={headerStyle}>
                            Remarks
                          </TableCell>
                        </TableRow>
                      </TableHead>

                      {/* ================= Table Body ================= */}

                      <TableBody>

                        {/* Data Rows */}

                        {paginatedData && paginatedData.length > 0 ? (
                          paginatedData.map((row, index) => (
                            <TableRow
                              key={page * rowsPerPage + index}
                              sx={{
                                backgroundColor: isGHMC()
                                  ? index % 2 === 0
                                    ? "#8fc9ff"
                                    : "#aed8ff"
                                  : index % 2 === 0
                                  ? "#F8CCCD"
                                  : "#ffeded",
                              }}
                            >
                              <TableCell sx={cellStyle}>
                                {page * rowsPerPage + index + 1}
                              </TableCell>

                              <TableCell sx={cellStyle}>
                                <span
                                  style={{ color: "blue", cursor: "pointer" }}
                                  onClick={(e) =>
                                    handleDateClick(row.date, e)
                                  }
                                >
                                  {formattedDate(row.date)}
                                </span>
                              </TableCell>

                              <TableCell sx={cellStyle}>
                                {row.shiftName || "-"}
                              </TableCell>

                              <TableCell sx={cellStyle}>
                                {row.totalGVPs || 0}
                              </TableCell>

                              <TableCell sx={cellStyle}>
                                {row.attended || 0}
                              </TableCell>

                              <TableCell sx={cellStyle}>
                                {row.performance || 0}
                              </TableCell>

                              <TableCell sx={cellStyle}>
                                {row.remarks || "-"}
                              </TableCell>
                            </TableRow>
                          ))
                        ) : (
                          /* No Data */
                          <TableRow>
                            <TableCell
                              colSpan={7}   // ✅ fixed
                              sx={{ ...cellStyle, textAlign: "center" }}
                            >
                              No data available
                            </TableCell>
                          </TableRow>
                        )}

                        {/* ================= Total Row ================= */}

                        {frequencyBinsGVPData &&
                          frequencyBinsGVPData.length > 0 && (
                            <TableRow
                              sx={{
                                backgroundColor: isGHMC()
                                  ? "#0d5da5"
                                  : "#EC1117",
                                "& .MuiTableCell-root": {
                                  color: "#fff",
                                  fontWeight: 700,
                                },
                              }}
                            >
                              <TableCell sx={cellStyle} colSpan={3}>
                                Grand Total
                              </TableCell>

                              <TableCell sx={cellStyle}>
                                {totals.totalGVPs}
                              </TableCell>

                              <TableCell sx={cellStyle}>
                                {totals.attended}
                              </TableCell>

                              <TableCell sx={cellStyle}>
                                {/* {totals.performance} */}
                              </TableCell>

                              <TableCell sx={cellStyle}>
                                
                              </TableCell>
                            </TableRow>
                          )}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  {/* ================= Pagination ================= */}

                  <TablePagination
                    component="div"
                    count={frequencyBinsGVPData?.length || 0}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    rowsPerPageOptions={[500, 1000, 2000]}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FrequencyOfBinsReport;
